const APPLOVIN_PUBLISHER_IDS = [
  '6710dc8e12f3a4c8272e341c',
  '6710e64712f3a4c8272e5d8e',
  '6710e6ee115191ad5cf0f781',
  '659a9ed93bd8ec8655b07bea',
  '66014f689a22b5e94be669da',
  '66014f8b9a22b5e94be66a01',
  '6710da03c20d5faff5f9dbc1',
  '676443587cf41895c475f799',
  '676444c686042473dd1fd12e',
  '6764450d81adb3efc4d159b4',
  '676816527f245d590b434e2a',
  '677e2f736e71d7538e512589',
  '6809f90f46f028bbd153f371',
  '680a48f255e5b03f8b7af7af',
  '6814778478260ae482e58fb0',
  '68241afca135b3efbc7e5e80',
  '68380b3acdc1e3f1a0003c63',
  '68380c1a369f22cad19cae57',
  '68380c914e4c878673952957',
  '685d5883369bbc98e6c3355e',
  '685d58ae369bbc98e6c33d7e',
  '685d58ddbbaf6cd6f4269923',
  '685d5901bd437e469db9b40e',
  '685d5921369bbc98e6c353f6',
  '685d594f369bbc98e6c35b17',
  '685d5972addd9e8165d14113',
  '685d59a0addd9e8165d14a4b',
  '685d59c5bd437e469db9d882',
  '685d59eebbaf6cd6f426cbc9',
  '685d8d48bd437e469dc0434e',
  '685d8e50bbaf6cd6f42d4e8c',
  '687f3c4dd7cc1c992d8b9c20',
  '689252f8e60a0b9bd27e3ed5',
  '68cd082456d9b6d8dd872766',
  '68c023cce28d426b42ec1acc',
  '68a465065ed3ec413826e275',
];

const KING_PUBLISHER_IDS = [
  '68ef50dda7edac3dce87f9b9',
  '68f1088a2a1f2cf64a3b7e0f',
  '68f60901c00b167ce32e4486',
  '68f607558045124a51b3d357',
];

const VIZOR_PUBLISHER_IDS = [
  '68d6424e51a85160ca31be33',
  '68da62d81bf79105a5b20984',
  '68da7fe41bf79105a5b2b4f7',
  '68f15d202a1f2cf64a3d3179',
  '69020598b3297f944de30e58',
  '690205c0b3297f944de310bc',
  '6924322b5cb4268f1e60f503',
  '6901f9f1dd40d139b57a3072',
  '69020a05f5a8d290bc2932c9',
  '690b3382a71345441150c053',
];

const publisherIdToTOSMap: Record<string, string> = {
  '6710dc8e12f3a4c8272e341c': 'https://www.mz.com/terms-of-use/en/',
  '6710e64712f3a4c8272e5d8e': 'https://www.mz.com/terms-of-use/en/',
  '6710e6ee115191ad5cf0f781': 'https://www.zenlifegames.com/terms/',
  '659a9ed93bd8ec8655b07bea': 'https://zeroogravitygames.com/terms.html',
  '66014f689a22b5e94be669da': 'https://zeroogravitygames.com/terms.html',
  '66014f8b9a22b5e94be66a01': 'https://zeroogravitygames.com/terms.html',
  '6710da03c20d5faff5f9dbc1': 'https://www.mz.com/terms-of-use/en/',
  '676443587cf41895c475f799': 'https://www.mz.com/terms-of-use/en/',
  '676444c686042473dd1fd12e': 'https://www.mz.com/terms-of-use/en/',
  '6764450d81adb3efc4d159b4': 'https://www.mz.com/terms-of-use/en/',
  '676816527f245d590b434e2a': 'https://www.mz.com/terms-of-use/en/',
  '677e2f736e71d7538e512589': 'https://www.mz.com/terms-of-use/en/',
  '6809f90f46f028bbd153f371': 'https://www.mz.com/terms-of-use/en/',
  '680a48f255e5b03f8b7af7af': 'https://www.mz.com/terms-of-use/en/',
  '6814778478260ae482e58fb0': 'https://www.mz.com/terms-of-use/en/',
  '68241afca135b3efbc7e5e80': 'https://www.mz.com/terms-of-use/en/',
  '68380b3acdc1e3f1a0003c63': 'https://zeroogravitygames.com/terms.html',
  '68380c1a369f22cad19cae57': 'https://zeroogravitygames.com/terms.html',
  '68380c914e4c878673952957': 'https://zeroogravitygames.com/terms.html',
  '685d5883369bbc98e6c3355e': 'https://www.mz.com/terms-of-use/en/',
  '685d58ae369bbc98e6c33d7e': 'https://www.mz.com/terms-of-use/en/',
  '685d58ddbbaf6cd6f4269923': 'https://www.mz.com/terms-of-use/en/',
  '685d5901bd437e469db9b40e': 'https://www.mz.com/terms-of-use/en/',
  '685d5921369bbc98e6c353f6': 'https://www.mz.com/terms-of-use/en/',
  '685d594f369bbc98e6c35b17': 'https://www.mz.com/terms-of-use/en/',
  '685d5972addd9e8165d14113': 'https://www.mz.com/terms-of-use/en/',
  '685d59a0addd9e8165d14a4b': 'https://www.mz.com/terms-of-use/en/',
  '685d59c5bd437e469db9d882': 'https://www.zenlifegames.com/terms/',
  '685d59eebbaf6cd6f426cbc9': 'https://www.mz.com/terms-of-use/en/',
  '685d8d48bd437e469dc0434e': 'https://www.mz.com/terms-of-use/en/',
  '685d8e50bbaf6cd6f42d4e8c': 'https://www.mz.com/terms-of-use/en/',
  '687f3c4dd7cc1c992d8b9c20': 'https://www.mz.com/terms-of-use/en/',
  '689252f8e60a0b9bd27e3ed5': 'https://www.mz.com/terms-of-use/en/',
  '68cd082456d9b6d8dd872766': 'https://www.mz.com/terms-of-use/en/',
  '68c023cce28d426b42ec1acc': 'https://www.mz.com/terms-of-use/en/',
  '68a465065ed3ec413826e275': 'https://www.zenlifegames.com/terms/',
};

export function getIsApplovin(publisherId?: string) {
  return APPLOVIN_PUBLISHER_IDS.includes(publisherId || '');
}

export function getTOS(publisherId?: string) {
  return publisherIdToTOSMap[publisherId || ''];
}

export function getIsKingPublisher(publisherId?: string) {
  return KING_PUBLISHER_IDS.includes(publisherId || '');
}

export function getIsVizorPublisher(publisherId?: string) {
  return VIZOR_PUBLISHER_IDS.includes(publisherId || '');
}
